import { VersionHistory } from "types"

export const versions: VersionHistory[] = [
    {
        version: "1.2.2",
        releaseDate: "05/15/2024",
        changes: [
            //UI components for Email collection
        ]
    },
    {
        version: "1.2.1",
        releaseDate: "01/17/2024",
        changes: [
            "fixed the bug where quantity on catch weight items were miscalculated on recap page" //(DTI-6473)
        ]
    },
    {
        version: "1.2.0",
        releaseDate: "01/08/2024",
        changes: [
            "Option to view Catch Weights by PO" 
            // Logic added to Catch Weight's so they'll verify on the appropriate order item, 
            // added delay when calling complete stop to try to prevent race conditions
        ]
    },
    {
        version: "1.1.5",
        releaseDate: "12/20/2023",
        changes: [
            "Catch weight pop up verbage has now been changed", //(DTI-6460)
            // Dynaman base URL has been updated (DTI-6484)
            // Many unit tests have been converted to use React testing library 
        ]
    },
    {
        version: "1.1.4",
        releaseDate: "11/08/2023",
        changes: [
            // Stop completions are no longer held up by mismatching signature Ids (DTI-5806)
            // Unit tests have been converted to use React testing library (DTI-6282), (DTI-6280), (DTI-6277), (DTI-6275), (DTI-6274), 
            // (DTI-6269), (DTI-6268), (DTI-6267), (DTI-6266), (DTI-6264), (DTI-6263)
        ]
    },
    {
        version: "1.1.3",
        releaseDate: "09/22/2023",
        changes: [
            "Catch weight changes are now reflected in the PO Totals on the Recap screen", //DTI-5806
            "Fixed duplicate items displaying in PO changes screen", //DTI-5522
            "When Mass Refusing, verified catch weight items can now be included when clicking the 'Delete All' button" //DTI-5543
            //Damage photos will download from blob storage when loading in an app-state (DTI-5766)
        ]
    },
    {
        version: "1.1.2",
        releaseDate: "08/25/2023",
        changes: [
            "You will now be notified when an item is for multiple customers", //DTI-5124
            "Fixed duplicate items displaying in PO changes screen" //DTI-5522
            //issue reports can now be sent when stuck on "Loading..." during an update (DTI-5438)
            //refusal images are now included in app states (DTI-5774)
        ]
    },
    {
        version: "1.1.1-2",
        releaseDate: "07/05/2023",
        changes: [
            "Fixed an issue where some loads were getting stuck in waiting" //"importing" status was not being accounted for in data merge
        ]
    },
    {
        version: "1.1.1-1",
        releaseDate: "06/28/2023",
        changes: [
            //fixed new "importing" status showing up on load assignments
        ]
    },
    {
        version: "1.1.1",
        releaseDate: "06/16/2023",
        changes: [
            "CHEP pallets no longer need to be counted",
            "Fixed mass verify not verifying all catch weights"
            //an automatic app state is now sent when signatures are missing/do not match
        ]
    },
    {
        version: "1.1.0-1",
        releaseDate: "05/12/2023",
        changes: [
            "📸 You can now upload photos of refused product",
            "✔ Changes must now be verified before moving to recap"
            //Fixed invalid catch weight values
            //Fixed some custom hauls being sent to reconcile
        ]
    },
    {
        version: "1.0.4",
        releaseDate: "02/17/2023",
        changes: [
            "A reminder for stamped DRs is now displayed on the recap"
        ]
    },
    {
        version: "1.0.3",
        releaseDate: '02/03/2023',
        changes: [
            "Fixed inaccurate PO weights and cubes",
            "Fixed getting stuck on the recap in some scenarios"
        ]
    },
    {
        version: "1.0.2",
        releaseDate: '01/06/2023',
        changes: [
            "Improved barcode recognition of some products that would not scan",
            "Fixed delivered quantity on recap not being calculated correctly in some scenarios",
            "Issue reports can now be sent while offline"
        ]
    },
    {
        version: "1.0.1-7",
        releaseDate: '11/28/2022',
        changes: [
            "Fixed some catch weight refusals added to wrong case",
            "Fixed some stops getting stuck while syncing"
        ]
    },
    {
        version: "1.0.1-6",
        releaseDate: '11/3/2022',
        changes: [
            "Fixed not being able to enter a return sticker on refusals",
        ]
    },
    {
        version: "1.0.1-5",
        releaseDate: '10/13/2022',
        changes: [
            "A warning is now displayed when shorting a scanned item to zero",
            "Stops with sync errors are now visible from the appointments page",
            "Added validation to ensure no duplicate return stickers are used",
            "Fixed \"Verify All\" option on catch weights when verified items were hidden",
            "Fixed performance issues with large lists",
            "Fixed not being able to search for some items when adding a mispick",
            "Fixed not being able to enter return stickers in some situations",
            "Fixed return stickers on overage refusals"
        ]
    },
    {
        version: "1.0.1-4",
        releaseDate: "09/27/2022",
        changes: [
            "Fixed some scans not verifying items",
            "Your trailer number is now displayed on pickups",
            "DC city and state are now displayed on pickups",
            "A message is now displayed when scanning an item for multiple customers",
            "Fixed returns not being considered on some recaps",
        ]
    },
    {
        version: "1.0.1-3",
        releaseDate: "09/09/2022",
        changes: [
            "A warning is now displayed when scanning hazardous materials",
            "Catch weights are now sorted to make them easier to find",
            "Fixed date not required on code date refusals",
            "Added validation to mispick quantities",
            "Removed disco mode ✨🕺",
        ]
    },
    {
        version: "1.0.1",
        releaseDate: "04/15/2022",
        changes: [
            //"Loads will now drop off after 3 days instead of 7", //reverted
            "Fixed recapping STC with unverified items"
            //Updated node version, npm packages. No need to inform users.
        ]
    },
    {
        version: "1.0.0-40",
        releaseDate: "07/08/2022",
        changes: [
            "Fixed duplicate refusal entries while scanning"
        ]
    },
    {
        version: "1.0.0-39",
        releaseDate: "07/08/2022",
        changes: [
            "Fixed quantity adjustment when item on multiple of same PO"
        ]
    },
    {
        version: "1.0.0-38",
        releaseDate: "07/06/2022",
        changes: [
            "Fixed issue where line items associated with returns were being removed"
        ]
    },
    {
        version: "1.0.0-37",
        releaseDate: "06/23/2022",
        changes: [
            "Fixed counted quantity carry over while scanning"
        ]
    },
    {
        version: "1.0.0-36",
        releaseDate: "06/22/2022",
        changes: [
            "Fixed invalid counted quantities"
        ]
    },
    {
        version: "1.0.0-35",
        releaseDate: "06/20/2022",
        changes: [
            "Fixed not being able to make some catch weight changes"
        ]
    },
    {
        version: "1.0.0-33",
        releaseDate: "06/13/2022",
        changes: [
            "Added return sticker validation"
        ]
    },
    {
        version: "1.0.0",
        releaseDate: "01/05/2022",
        changes: [
            "Added ability to filter by multiple LPs",
            "Made back button easier to use with gloves",
            "Added welcome page",
            "Added item descriptions to mispicks",
            "Fixed mass verification not verifying all LPs",
            "Fixed temperature sensitive LPs",
            "Fixed loads not completing after recap",
            "Fixed signature offset from finger",
            "Fixed issues with offline logout",
            "Various enhancements and bug fixes"
        ]
    },
    {
        version: "0.9.2",
        releaseDate: "11/22/2021",
        changes: [
            "Added ability to view completed recaps from stop overview",
            "Removed mass verification/refuse by LP",
            "Fixed Okta logout on spotty internet connection",
            "Fixed recap being editable after completion",
            "Fixed loads not being available offline",
            "Fixed mass verification not working for catch weights",
            "Fixed catch weight shortages asking for return sticker",
            "Fixed catch weights excluded from PO shipped quantities",
            "Fixed mispicks detected as error from mispicks page",
            "Fixed catch weight changes not displaying on stop overview",
            "Fixed \"Loading\" popup not being displayed"
        ]
    },
    {
        version: "0.9.1",
        releaseDate: "10/25/2021",
        changes: [
            "Fixed automatic logout after 1 hour",
            "Improved overage/refusal wording",
            "Improved visibility of delivered quantity when verifying an item",
            "Moved training mode to user menu",
            "Improved login page",
            "Improved reliability of stop completion when errors occur",
            "Added new option to enter training mode when no loads are found",
            "Changed \"Error\" to \"Notice\" when no loads are found"
        ]
    },
    {
        version: "0.9.0",
        releaseDate: "10/6/2021",
        changes: [
            "Added \"What's New\" popup 😃",
            "Fixed new loads not getting downloaded to the device",
            "Fixed mass verification on STC stops",
            "Fixed items getting verified before all LPs are checked",
            "Performance enhancements",
            "Minor bugfixes"
        ]
    }
]